<template>

  <div
    id="app"
    v-cloak>
    <keep-alive exclude='video-details'>
      <router-view :key="$route.fullPath"/>
    </keep-alive>
  </div>

</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted() {
  },
}
</script>

<style  lang="scss">

[v-cloak] {
  display: none;
}

html,
body,

#app {
  position: relative;
  margin: 0 auto;
  height: 100%;
  // background: #7540de;
  // min-height:px2rem(1080);
}
</style>
